if ( typeof ProductPage !== 'function' ) {

	class ProductPage extends HTMLElement {

		constructor(){

			super();

			this.productGallery = this.querySelector('[data-js-product-gallery]');
			this.productSlider = this.querySelector('css-slider');

			this.pickupAvailabilityExtended = this.querySelector('pickup-availability-extended');

			// Gallery thumbnails

			if ( this.productSlider ) {

				if ( this.querySelector('.product-gallery__thumbnails .thumbnail') ) {

					this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i)=>{
						if ( i == 0 )  {
							elm.classList.add('active');
						}
						elm.addEventListener('click',e=>{
							if ( this.productSlider.sliderEnabled ) {
								this.productSlider.changeSlide(e.currentTarget.dataset.index);
							} else {
								window.scrollTo({
									top: this.productGallery.querySelector(`.product-gallery-item[data-index="${e.currentTarget.dataset.index}"]`).getBoundingClientRect().top,
									behavior: 'smooth'
								});
								this.thumbnailNavigationHelper(e.currentTarget.dataset.index);
							}
						});
					})

					this.productSlider.addEventListener('change', e=>{
						this.thumbnailNavigationHelper(e.target.index);
					});

				}

				this.productSlider.addEventListener('change', e=>{
					if ( this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`).dataset.productMediaType == 'model' ) {
						if ( this.xrButton ) {
							this.xrButton.setAttribute('data-shopify-model3d-id', this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`).dataset.mediaId);
						}
						setTimeout(()=>{
							this.productSlider.querySelector('.css-slider-holder').classList.add('css-slider--disable-dragging');
						}, 150);
					}
				});

				// Parallax

				this.productSlider.addEventListener('ready', (e)=>{
					if ( this.firstProductGalleryIndex ) {
						this.productSlider.changeSlide(this.firstProductGalleryIndex, "auto");
					}
				});

			}

			// Product variant event listener for theme specific logic

			this.productVariants = this.querySelector('product-variants[data-main-product-variants]');
			if ( this.productVariants ) {

				this.productVariants.addEventListener('VARIANT_CHANGE', this.onVariantChangeHandler.bind(this));
				this.onVariantChangeHandler({target:this.productVariants});

				// refresh color
				this.querySelectorAll('.product-variant__item--radio input').forEach(input=>{
					input.addEventListener('click', () => {
						const inputParent = input.closest('.product-variant__item--radio');
						if ( inputParent.classList.contains('product-variant__item--color' ) ) {
							inputParent.closest('.product-variant').querySelector('.product-variant__item-text-label').textContent = input.value;
						}
					})
				});

			}

			// show cart drawer when element is added to cart

			if ( ! document.body.classList.contains('template-cart') && KROWN.settings.cart_action == 'overlay' ) {
				
				let addToCartEnter = false;
				if ( this.querySelector('[data-js-product-add-to-cart]') ) {
					this.querySelector('[data-js-product-add-to-cart]').addEventListener('keyup', e=>{
						if ( e.keyCode == window.KEYCODES.RETURN ) {
							addToCartEnter = true;
						}
					})
				}	

				if ( this.querySelector('[data-js-product-form]') ) {
					this.querySelector('[data-js-product-form]').addEventListener('add-to-cart', ()=>{
						document.getElementById('site-cart-sidebar').show();
							if ( document.getElementById('cart-recommendations-sidebar') ) {
							document.getElementById('cart-recommendations-sidebar').generateRecommendations();
						}
						if ( addToCartEnter ) {
							setTimeout(()=>{
								document.querySelector('#site-cart-sidebar [data-js-close]').focus();
							}, 200);
						}
					});
				}

			}

			// Check for models

			const models = this.querySelectorAll('product-model');
			if ( models.length > 0 ) {
				window.ProductModel.loadShopifyXR();
				this.xrButton = this.querySelector('.product-gallery__view-in-space');
			}

			// hide buy now button if stock disabled

			const addToCartButton = this.querySelector('[data-js-product-add-to-cart][data-main-product-add-to-cart]');
			if ( addToCartButton ) {
				if ( addToCartButton.classList.contains('disabled') ) {
					this.querySelector('product-form').classList.add('disable-buy-button');
				} else {
					this.querySelector('product-form').classList.remove('disable-buy-button');
				}
				const buyObserver = new MutationObserver(()=>{
					if ( addToCartButton.classList.contains('disabled') ) {
						this.querySelector('product-form').classList.add('disable-buy-button');
					} else {
						this.querySelector('product-form').classList.remove('disable-buy-button');
					}
				});
				buyObserver.observe(addToCartButton,{ attributes: true, childList: false, subtree: false });
			}

		}

		thumbnailNavigationHelper(index=0){
			this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i)=>{
				if ( i == index ) {
					elm.classList.add('active');
					this.querySelector('.product-gallery__thumbnails-holder').scrollTo({
						left: elm.offsetLeft - 50,
						behaviour: 'smooth'
					})
				} else {
					elm.classList.remove('active');
				}
			});
		}

		onVariantChangeHandler(e){

			let variant = e.target.currentVariant;
			if ( variant ) {
				
				// image handling

				if ( variant.featured_media != null ) {
					let variantImg = this.productGallery.querySelector('.product-gallery-item[data-media-id="' + variant.featured_media.id + '"]');
					if ( variantImg ) {
						if ( this.productGallery.classList.contains('product-gallery--slider') || ( this.productGallery.classList.contains('product-gallery--scroll') && window.innerWidth < 1024 ) ) {
							if ( this.productGallery.querySelector('css-slider') && this.productGallery.querySelector('css-slider').sliderEnabled ) {
								this.productGallery.querySelector('css-slider').changeSlide(variantImg.dataset.index);
							} else {
								this.firstProductGalleryIndex = variantImg.dataset.index;
							}
						} else {
							variantImg.scrollIntoView({behavior: 'smooth', block: 'center'});
						}
					}
				}
				
				this.querySelectorAll('.product-variant__item--color [data-selected]').forEach(elm=>{
					elm.closest('.product-variant').querySelector('.product-variant__item-text-label').textContent = elm.value;
				});

			}

		}
		
	}

  if ( typeof customElements.get('product-page') == 'undefined' ) {
		customElements.define('product-page', ProductPage);
	}

}

/* ── Highlights block: hide orphan dividers when items wrap ── */
(function () {
  function updateHighlightDividers(block) {
    var items    = block.querySelectorAll('.product-highlights__item');
    var dividers = block.querySelectorAll('.product-highlights__divider');
    dividers.forEach(function (div, i) {
      var prev = items[i], next = items[i + 1];
      if (!prev || !next) return;
      var sameRow = Math.abs(next.getBoundingClientRect().top - prev.getBoundingClientRect().top) < 5;
      div.style.display = sameRow ? '' : 'none';
    });
  }

  function initHighlights() {
    document.querySelectorAll('.product-highlights').forEach(function (block) {
      updateHighlightDividers(block);
      if (window.ResizeObserver) {
        new ResizeObserver(function () { updateHighlightDividers(block); }).observe(block);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHighlights);
  } else {
    initHighlights();
  }
}());

/* Buy box "View sample plans" (finance steps) → open the native Shop Pay installments modal.
   That modal is owned by the <shopify-payment-terms> widget already on the page, so we
   click its own sample-plans link. If a custom URL is set on the link, let it navigate. */
(function () {
  function openShopPayPlans() {
    var terms = document.querySelector('shopify-payment-terms');
    if (!terms) return false;
    var scope = terms.shadowRoot || terms;
    var els = scope.querySelectorAll('a, button, [role="button"]');
    var hit = null;
    for (var i = 0; i < els.length; i++) {
      if (/sample|learn|plan/i.test(els[i].textContent || '')) { hit = els[i]; break; }
    }
    if (!hit && els.length) hit = els[0];
    if (hit) { hit.click(); return true; }
    if (typeof terms.click === 'function') { terms.click(); return true; }
    return false;
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('.bbw-fin__link');
    if (!t) return;
    var href = t.getAttribute('href');
    if (href && href !== '#') return;  /* custom URL set — navigate normally */
    e.preventDefault();
    openShopPayPlans();
  });
}());

/* "How many riders?" selector — drives the buy-box quantity (Just me = 1, Ride together = 2+)
   and updates the indicative BoTogether savings live. The real 10% discount is applied in cart. */
(function () {
  function ridersMoney(cents, fmt) {
    var whole = Math.round((cents || 0) / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return ((fmt || '${{amount}}').replace(/\{\{\s*amount[^}]*\}\}/g, whole)).replace(/<[^>]+>/g, '').trim();
  }
  if (typeof customElements.get('riders-selector') === 'undefined') {
    class RidersSelector extends HTMLElement {
      connectedCallback() {
        if (this._init) return;
        this._init = true;
        var self = this;
        this.cards = Array.prototype.slice.call(this.querySelectorAll('[data-riders-card]'));
        this.qtyInput = this.querySelector('[data-riders-count]');
        this.saveEl = this.querySelector('[data-riders-savings]');
        this.saveEach = parseInt(this.dataset.saveEach || '0', 10);
        this.fmt = this.dataset.moneyFormat || '${{amount}}';
        var current = parseInt((this.qtyInput && this.qtyInput.value) || '2', 10);
        this.togetherQty = current >= 2 ? current : 2;
        this.cards.forEach(function (c) {
          c.addEventListener('click', function () { self.select(c.getAttribute('data-riders-card')); });
          c.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ' || e.keyCode === 13 || e.keyCode === 32) {
              e.preventDefault();
              self.select(c.getAttribute('data-riders-card'));
            }
          });
        });
        var minus = this.querySelector('[data-riders-minus]');
        var plus = this.querySelector('[data-riders-plus]');
        if (minus) minus.addEventListener('click', function (e) { e.stopPropagation(); if (self.togetherQty <= 2) { self.select('solo'); } else { self.step(-1); } });
        if (plus) plus.addEventListener('click', function (e) { e.stopPropagation(); self.step(1); });
        var checked = this.querySelector('[data-riders-card][aria-checked="true"]');
        this.select(checked ? checked.getAttribute('data-riders-card') : 'solo', true);
      }
      get mode() {
        var c = this.querySelector('[data-riders-card][aria-checked="true"]');
        return c ? c.getAttribute('data-riders-card') : 'solo';
      }
      select(mode, silent) {
        this.cards.forEach(function (c) {
          var on = c.getAttribute('data-riders-card') === mode;
          c.setAttribute('aria-checked', on ? 'true' : 'false');
          c.classList.toggle('is-selected', on);
        });
        if (this.qtyInput) this.qtyInput.value = (mode === 'together') ? this.togetherQty : 1;
        this.updateSavings();
        this.updateStepper();
        if (!silent && this.qtyInput) this.qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      step(dir) {
        this.togetherQty = Math.max(2, this.togetherQty + dir);
        if (this.mode !== 'together') { this.select('together'); return; }
        if (this.qtyInput) {
          this.qtyInput.value = this.togetherQty;
          this.qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        this.updateSavings();
        this.updateStepper();
      }
      updateStepper() {
        var stepper = this.querySelector('.riders__stepper');
        if (stepper) stepper.classList.toggle('is-min', this.togetherQty <= 2);
      }
      updateSavings() {
        if (this.saveEl) this.saveEl.textContent = 'save ' + ridersMoney(this.saveEach * this.togetherQty, this.fmt);
      }
    }
    customElements.define('riders-selector', RidersSelector);
  }
}());
